import type { VinDecodeFields } from "@autorepair/contracts";

/** Shared by VehicleDetailsModal and VehicleForm's own read-only "From the
 * VIN" section — one list so the two never drift apart. */
export const VIN_FIELD_LABELS: [key: keyof VinDecodeFields, label: string][] = [
  ["trim", "Trim"],
  ["series", "Series"],
  ["engineDisplacementL", "Engine Displacement (L)"],
  ["engineCylinders", "Cylinders"],
  ["engineConfiguration", "Engine Configuration"],
  ["bodyClass", "Body Class"],
  ["driveType", "Drive Type"],
  ["fuelTypePrimary", "Fuel Type"],
  ["transmissionStyle", "Transmission"],
  ["plantCountry", "Built In"],
  ["manufacturer", "Manufacturer"],
];

const CONFIG_LETTERS: Record<string, string> = {
  "V-Shaped": "V",
  "W-Shaped": "W",
  Inline: "I",
  "In-Line": "I",
  Flat: "F",
  "Horizontally Opposed": "F",
  Rotary: "R",
};

/** Matches the plan's verified NHTSA field-mapping recipe: "{DisplacementL}L,
 * {config_letter}{cylinders}" — e.g. "3.5L, V6". VIN(J)-style engine-code
 * suffixes are deliberately never composed here (see FRONTEND_BACKLOG.md —
 * confirmed as legacy data with no meaning for this shop). */
export function composeEngineDescription(fields: VinDecodeFields): string {
  const parts: string[] = [];
  if (fields.engineDisplacementL) parts.push(`${fields.engineDisplacementL}L`);
  const configLetter = fields.engineConfiguration ? CONFIG_LETTERS[fields.engineConfiguration] : undefined;
  if (configLetter && fields.engineCylinders) parts.push(`${configLetter}${fields.engineCylinders}`);
  else if (fields.engineCylinders) parts.push(`${fields.engineCylinders} cyl`);
  return parts.join(", ");
}
